import React, { useState } from "react";
import { Row, Col, Container, Button, Form, Badge } from "react-bootstrap";

import MachineFamilyListStats from "./MachineFamilyListStats.js";
import CustomerListStats from './CustomerListStats.js';
import SNMachineListStats from './SNMachineListStats.js';
import DateRangeSelectorStats from './DateRangeSelectorStats.js';
import ButtonStartAnalysisStats from "./ButtonStartAnalysisStats.js";

import { useGlobalState } from '../../components/globalStateProvider.js';

function AnalisiErroreStatisticaPage() {    
    const { 
        statsBlocks, addStatsBlock, updateStatsBlock, setStatsBlocks,
        alarmCodes, addAlarmCode, removeAlarmCode
    } = useGlobalState();

    const [newAlarmCode, setNewAlarmCode] = useState("");

    // Rimuove un blocco
    const removeBlock = (index) => {
        setStatsBlocks(prev => prev.filter((_, i) => i !== index));
    };

    // Controllo se il pulsante "aggiungi" deve essere abilitato
    const canAddBlock = statsBlocks.length === 0
        ? true
        : statsBlocks[statsBlocks.length - 1].snMachine !== "";

    // Controllo se PIPPO deve essere abilitato (tutti i blocchi con SN selezionato)
    const canStartAnalysis = statsBlocks.length > 0
        && statsBlocks.every(b => b.snMachine !== "");

    return (
        <Container>
            <Row className="text-center mt-4 mb-3">
                <h2>Analisi errori statistica</h2>
                <p className="mt-1">
                    Questa sezione presenta una panoramica della frequenza degli errori selezionati per i clienti selezionati
                </p>
            </Row>

            {/** INSERIMENTO CODICI ALLARME */}
            <Row className="mb-3 align-items-center">
                <h6>Inserisci i codici di allarmi</h6>
                <Col md={4}>
                    <Form.Control 
                        placeholder="Inserisci codice allarme e premi INVIO"
                        value={newAlarmCode}
                        onChange={e => setNewAlarmCode(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                addAlarmCode(newAlarmCode);
                                setNewAlarmCode("");
                            }
                        }}
                    />
                </Col>
                <Col md={6}>
                    {alarmCodes.map((code, i) => (
                        <Badge
                            key={i}
                            bg="info"
                            className="me-2"
                            style={{ cursor: "pointer" }}
                            onClick={() => removeAlarmCode(code)}
                        >
                            {code} &times;
                        </Badge>
                    ))}
                </Col>
            </Row>

            <hr className="mt-4 mb-5"/>

            <h6>Inserisci le macchine da analizzare</h6>

            {/** BLOCCI MULTI DROPDOWN ORIZZONTALI */}
            {statsBlocks.map((block, index) => (
                <Row key={index} className="align-items-center mb-2" style={{ gap: "1rem" }}>
                    <Col md style={{ minWidth: 150 }}>
                        <MachineFamilyListStats index={index} block={block} />
                    </Col>
                    <Col md style={{ minWidth: 150 }}>
                        {block.machineFamily !== 0 && block.listCustomerMachines.length > 0 && (
                            <CustomerListStats index={index} block={block} />
                        )}
                    </Col>
                    <Col md style={{ minWidth: 150 }}>
                        {block.machineFamily !== 0 &&
                         block.customerName !== "" &&
                         block.listSNMachines.length > 0 && (
                             <SNMachineListStats index={index} block={block} />
                        )}
                    </Col>
                    <Col md="auto">
                        <Button
                            variant="danger"
                            onClick={() => removeBlock(index)}
                        >
                            &times;
                        </Button>
                    </Col>
                </Row>
            ))}

            {/** BOTTONE PER AGGIUNGERE NUOVO BLOCCO */}
            <Row className="text-center mb-3">
                <Col>
                    <Button
                        variant="secondary"
                        onClick={addStatsBlock}
                        disabled={!canAddBlock}
                    >
                        + Aggiungi SN Machine
                    </Button>
                </Col>
            </Row>

            {/** TIME RANGE UNICO */}
            <Row className="mb-3">
                <Col md={{ span: 4, offset: 4 }}>
                    {statsBlocks.some(b =>
                        b.machineFamily !== 0 &&
                        b.customerName !== "" &&
                        b.listSNMachines.length > 0 &&
                        b.snMachine !== ""
                    ) && <DateRangeSelectorStats />}
                </Col>
            </Row>

            {/** PULSANTE FINALE "INIZIA ANALISI" */}
            <ButtonStartAnalysisStats />

        </Container>
    );
}

export default AnalisiErroreStatisticaPage;
